import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tabs } from '@delmonicos/shared-design-system-react/src/components/tab/tabs.component';
import {
  extractTabKeys,
  useTabQuery,
} from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/hooks';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { EmspBoChargingSessionStatusListController } from '../emsp-bo-charging-session-status-list/emsp-bo-charging-session-status-list.controller';
import { SessionInfoCardComponent } from './cards/session-info-card.component';
import { SessionLocationCardComponent } from './cards/session-location-card.component';
import { SessionTokenCardComponent } from './cards/session-token-card.component';

enum TabsEnum {
  INFORMATION = 'information-tab',
}

export const EmspBoChargingSessionDetailsView = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  // Nothing to do

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // TABS //////////////////////////////////////////////////////////////////////

  const tabs = useMemo(
    () =>
      [
        {
          title: t('$.emsp-bo-charge-session.information.title'),
          icon: 'electric-car-02',
          key: TabsEnum.INFORMATION,
        },
      ] as const,
    [t],
  );

  const { tab } = useTabQuery(TabsEnum.INFORMATION, extractTabKeys(tabs));

  const renderTab = () => {
    switch (tab) {
      case TabsEnum.INFORMATION:
        return (
          <Stack flex={1} gap={GapEnum.M}>
            <Stack flex={1} gap={GapEnum.M} direction="column">
              <SessionLocationCardComponent />
              <SessionTokenCardComponent />
            </Stack>
            <Stack flex={1} gap={GapEnum.M} direction="column">
              <EmspBoChargingSessionStatusListController />
              <SessionInfoCardComponent />
            </Stack>
          </Stack>
        );
      default:
        return null;
    }
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack flex={1} direction="column" gap={GapEnum.XL}>
      {tabs.length > 1 && (
        <Tabs currentTab={tab} elements={tabs} onTabClick={() => {}} />
      )}
      {renderTab()}
    </Stack>
  );
};
